import React, { Fragment } from 'react';
import { ErrorMessage, Field } from 'formik';
import CreditCardBrand from '../payment/CreditCardBrand';
import {
  StyledNumberField,
  StyledField,
  StyledSelect,
  StyledRadio,
  StyledErrorLabel,
  InputWrapper,
  StyledLabel,
  StyledWrapper,
  StyledBrand
} from './style';

const handleProps = (props) => {
  const attrs = { ...props };

  attrs.id = attrs.name;

  if(attrs.options){
    attrs.children = [];

    if(attrs.includeBlank !== 'false' && attrs.includeBlank !== false){
      attrs.children.push(
        <option value="" key="emptyValue">{attrs.placeholder}</option>
      );
    }

    attrs.options.map((option, i) => {
      let value;

      if(attrs.valueAttr){
        value = option[attrs.valueAttr];
      }
      else {
        value = option.value || option.id;
      }

      return attrs.children.push(
        <option key={i + 1} value={value}>
          {option.label || option.name || option.title}
        </option>
      )
    });
  }

  delete attrs.includeBlank;
  delete attrs.options;
  delete attrs.includeError;
  delete attrs.valueAttr;

  return attrs;
}

export const Input = (props) => {
  let attrs = handleProps(props);

  return (
    <StyledWrapper className="field">
      <InputWrapper>
        <Label {...attrs} />
        {props.children ? props.children : <InputField {...attrs} />}
        <ErrorLabel {...props} />
        <Brand {...attrs} />
      </InputWrapper>
    </StyledWrapper>
  )
}

export const Brand = (props) => {
  if(props.brand){
    return (
      <StyledBrand>
        <CreditCardBrand number={props.brand} />
      </StyledBrand>
    )
  }
  else return null;
}

export const FormField = ({ field, form, ...props }) => {
  if(props.children){
    return <StyledSelect {...field} {...props} />;
  }
  else if(props.type === 'radio'){
    return <StyledRadio {...field} {...props} />;
  }
  else {
    return <StyledField {...field} {...props} />;
  }
}

export const InputField = (props) => {
  if(props.format){
    return <StyledNumberField {...props} />;
  }
  else {
    return <Field {...props} component={FormField} />;
  }
}

export const Label = (props) => {
  if(props.label){
    return <StyledLabel htmlFor={props.name}>{props.label}</StyledLabel>;
  }
  else return null;
}

export const ErrorLabel = (props) => {
  if(props.includeError !== 'false' && props.includeError !== false){
    return <ErrorMessage name={props.name}>
      {message => <StyledErrorLabel className="error-label" htmlFor={props.name}>
        {message}
      </StyledErrorLabel>}
    </ErrorMessage>;
  }
  else {
    return null;
  }
}

export const RadioInput = (props) => {
  return (
    <Fragment>
      <StyledRadio {...props} />
      <label></label>
    </Fragment>
  )
}

export default Input;
